const ANSWER_KEYS = [
  'homeFactsCorrect',
  'homeUpdated',
  'isEstimateCorrect'
]

angular.module('homebot.directives')

.directive('cmaSection', ['Dictionary', function(Dictionary){
  return {
    restrict: 'A',
    controllerAs: 'cmaSectionCtrl',
    bindToController: {
      home: '=',
      userId: '@',
      onClose: '&',
    },
    scope: {},
    templateUrl: '/homes/templates/partials/cma-section.html',

    controller: function(){
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.lookup = function(prop,args){
        return dictionary[prop](ctrl.home,args);
      };

      ctrl.hasRecentlyRequested = function() {
        const hasRequestedCMA = ctrl.home.hasRequestedCMA;
        const oneYearAgo = moment().subtract(1,'year');
        return hasRequestedCMA && moment(hasRequestedCMA).isAfter(oneYearAgo);
      };

      ctrl.hasCompletedCMAQuestions = function() {
        return ANSWER_KEYS.every(key => ctrl.home.answers[key]);
      }

      ctrl.hasCompletedAndRequested = function() {
        return ctrl.hasRecentlyRequested() && ctrl.hasCompletedCMAQuestions();
      };

      ctrl.agent = ctrl.home.agent[0];
      ctrl.cmaSourceAgent = ctrl.lookup('cmaSourceAgent');
      ctrl.cmaProgress = ctrl.hasCompletedAndRequested() ? 'requested' : 'incomplete';

      ctrl.onCmaQuestionsComplete = function(requestedCma){
        if(requestedCma)
          ctrl.cmaProgress = 'requested';
        else
          ctrl.cmaProgress = 'skipped-request';
      };
    }
  }

}]);
